
import React from 'react';
import { Info, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';

const VelallisenOikeudetSection: React.FC = () => {
  return (
    <>
      <h2>Velallisen oikeudet ja suojaosuus</h2>
      <p>
        Ulosottokaaressa on säädetty velalliselle kuuluvista oikeuksista ja suojaosuudesta. Suojaosuus tarkoittaa 
        sitä vähimmäismäärää, joka velalliselle on jätettävä ulosmittauksessa elämiseen.
      </p>

      <div className="bg-blue-50 p-6 rounded-lg border border-blue-100 my-6">
        <h3 className="text-lg font-semibold mb-3 flex items-center">
          <Info size={20} className="mr-2 text-blue-600" /> 
          Ulosottovelallisen suojaosuudet 2025
        </h3>
        <p className="mb-4">
          Vuonna 2025 ulosotossa olevalle velalliselle jätettävä suojaosuus on <strong className="text-blue-700">32,88 euroa päivässä</strong> velallisen itsensä osalta ja <strong className="text-blue-700">9,61 euroa päivässä</strong> velallisen elatuksen varassa olevan henkilön, esimerkiksi lapsen, osalta.
        </p>
        <p className="mb-2">
          Suojaosuudet kuukaudessa (keskimäärin 30 päivää):
        </p>
        <ul className="list-disc pl-6 space-y-1 text-blue-700">
          <li><strong>Velallinen itse:</strong> 986,40 € / kk</li>
          <li><strong>Velallinen + 1 huollettava:</strong> 1 274,70 € / kk</li>
          <li><strong>Velallinen + 2 huollettavaa:</strong> 1 563,00 € / kk</li>
          <li><strong>Velallinen + 3 huollettavaa:</strong> 1 851,30 € / kk</li>
        </ul>
        <div className="mt-4 pt-4 border-t border-blue-200 text-sm">
          <p className="flex items-center text-blue-700">
            <ExternalLink size={16} className="mr-2" />
            <Link to="https://oikeusministerio.fi/-/suojaosuuden-maaraan-maaraajoin-maksettavan-palkan-ulosmittauksessa-ja-velkajarjestelyssa-huomioon-otettaviin-valttamattomiin-elinkustannuksiin-korotus-vuoden-2025-alussa" target="_blank" rel="noopener noreferrer" className="hover:underline">
              Lähde: Oikeusministeriö - Suojaosuuden määrä 2025
            </Link>
          </p>
        </div>
      </div>

      <p>
        Palkasta tai muusta säännöllisestä tulosta voidaan ulosmitata yleensä 1/3, mutta määrä vaihtelee tulojen 
        suuruuden mukaan. Suojaosuutta suuremmista tuloista ulosmittauksen määrä on porrastettu.
      </p>
    </>
  );
};

export default VelallisenOikeudetSection;
